"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setTimeoutAsync = undefined;

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _set = require("babel-runtime/core-js/set");

var _set2 = _interopRequireDefault(_set);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _map = require("babel-runtime/core-js/map");

var _map2 = _interopRequireDefault(_map);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var setTimeoutAsync = exports.setTimeoutAsync = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(timeout) {
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        return _context.abrupt("return", new _promise2.default(function (resolve, reject) {
                            setTimeout(function () {
                                return resolve();
                            }, timeout);
                        }));

                    case 1:
                    case "end":
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function setTimeoutAsync(_x) {
        return _ref.apply(this, arguments);
    };
}();

exports.showIf = showIf;
exports.generateItemsSets = generateItemsSets;
exports.propagateTextIconProp = propagateTextIconProp;
exports.propagateFunctionProp = propagateFunctionProp;
exports.validateChildComponentType = validateChildComponentType;

var _Category = require("./Category");

var _Category2 = _interopRequireDefault(_Category);

var _Item = require("./Item");

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function showIf(term, elem, elseElem) {
    if (term) {
        return elem();
    } else {
        return elseElem ? elseElem() : null;
    }
}

function generateItemsSets(children) {
    var itemsParent = new _map2.default();
    var itemsChild = new _map2.default();

    function fillParent(children, stack) {
        // TODO: crash prematurely when children is a (invalid) boolean value
        //  because the strange behavior of React.Children.forEach()
        React.Children.forEach(children, function (node) {
            if (node.type == _Category2.default) {
                fillParent(node.props.children, stack);
            } else if (node.type == _Item2.default) {
                itemsParent.set(node.key, stack);
                var newStack = [].concat((0, _toConsumableArray3.default)(stack), [node.key]);
                fillParent(node.props.children, newStack);
            }
        });
    }

    function fillChild(children) {
        React.Children.forEach(children, function (node) {
            if (node.type == _Category2.default) {
                fillChild(node.props.children);
            } else if (node.type == _Item2.default) {
                itemsParent.get(node.key).map(function (parentKey) {
                    if (!itemsChild.has(parentKey)) {
                        itemsChild.set(parentKey, new _set2.default());
                    }
                    var children = itemsChild.get(parentKey);
                    children.add(node.key);
                });
                fillChild(node.props.children);
            }
        });
    }

    fillParent(children, []);
    fillChild(children);

    return { itemsParent: itemsParent, itemsChild: itemsChild };
}

function propagateTextIconProp(childProp, parentProp) {
    if (typeof childProp == "boolean" || typeof childProp == "string") {
        return childProp;
    } else {
        return parentProp;
    }
}

function propagateFunctionProp(childProp, parentProp) {
    if (typeof childProp == "function") {
        return childProp;
    } else {
        return parentProp;
    }
}

function validateChildComponentType(item) {
    function invalidType() {
        console.error("The children of SliderBarNav should be SliderBarNav.Category or SliderBarNav.Item, found <" + (typeof item === "undefined" ? "undefined" : (0, _typeof3.default)(item)) + "> `" + item.toString() + "`");
    }
    if ((typeof item === "undefined" ? "undefined" : (0, _typeof3.default)(item)) != "object" || item.type != _Item2.default && item.type != _Category2.default) {
        return invalidType();
    }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-slider-bar-nav@0.0.38@@alicd/crui-slider-bar-nav/lib/util.js
// module id = 155
// module chunks = 0